import { FC, ReactNode } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiPaginationItem: {
      styleOverrides: {
        outlined: {
          border: 'none',
        },
        previousNext: {
          backgroundColor: 'transparent',
          color: '#D70000',
          border: '1px solid #D70000',
          fontSize: '1.2rem',
          display: 'grid',
          gap: '0.5rem',
          padding: '0.5rem',
          aspectRatio: '1/1 !important',
          '&:hover': {
            backgroundColor: '#D70000',
            color: '#ffffff',
          },
          '&:focus': {
            backgroundColor: '#D70000',
            color: '#ffffff',
          },
          '&.Mui-disabled': {
            color: '#CECECE',
            border: '1px solid #CECECE',
          },
          '&>svg': {
            width: '1rem',
          },
        },
        page: {
          lineHeight: '0',
          display: 'grid',
          gap: '0.5rem',
          '&:hover': {
            backgroundColor: 'transparent',
            color: '#D70000',
          },
          '&.Mui-selected': {
            backgroundColor: 'transparent',
            fontWeight: 'bold',
            color: '#D70000',
            '&:hover': {
              backgroundColor: 'transparent',
            },
          },
        },
      },
    },
  },
});

export const PaginationThemeProvider: FC<{ children: ReactNode }> = ({
  children,
}) => <ThemeProvider theme={theme}>{children}</ThemeProvider>;
